// extracted by mini-css-extract-plugin
module.exports = {"webviewNav":"WebviewNav_webviewNav__1Jjbg","webviewNav__backBtn":"WebviewNav_webviewNav__backBtn__3p-LB"};